import * as React from "react";

import { cn } from "./utils";

function Card({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border border-slate-200 shadow-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Card };
